import * as n from "react";
import { useWindowSize as h } from "./use-window-size.mjs";
const c = (t) => {
  var e;
  return t.hasChildNodes() ? ((e = t.childNodes[0]) == null ? void 0 : e.nodeType) === 3 ? t : c(t.childNodes[0]) : t;
}, a = (t, e) => {
  const [u, d] = n.useState(void 0), { width: f } = h();
  return n.useLayoutEffect(() => {
    const { current: s } = t, o = () => {
      const r = c(s);
      if (!r) return;
      const i = r.scrollWidth > s.clientWidth;
      d(i), e && e(i);
    };
    if (s) {
      const r = new MutationObserver(() => {
        o();
      });
      return r.observe(s, { childList: !0, subtree: !0, characterData: !0 }), o(), () => r.disconnect();
    }
  }, [e, t, f]), u;
};
export {
  a as useIsOverflowText
};
